export const ROLE_PERMS = {
  owner: ["*"],
  marketing_director: [
    "budget:write", "vendor:write", "lead:write", "lead:import", "invoice:write",
    "compliance:write", "alerts:send", "report:generate", "billing:manage", "integration:manage",
  ],
  intake_staff: ["lead:write"],
};

export const ROLE_LABELS = {
  owner: "Owner",
  marketing_director: "Marketing Director",
  intake_staff: "Intake Staff",
  viewer: "Demo (read-only)",
};

export const ASSIGNABLE_ROLES = ["owner", "marketing_director", "intake_staff"];

export function can(role, action) {
  const perms = ROLE_PERMS[role] || [];
  return perms.includes("*") || perms.includes(action);
}
